var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 46c0-24.853-20.147-45-45-45h-422c-24.853 0-45 20.147-45 45v90l10 10h492c3.905-3.905 6.095-6.095 10-10z",
    fill: "#0052c2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 46v90c-3.91 3.91-6.09 6.09-10 10h-246v-145h211c24.85 0 45 20.15 45 45z",
    fill: "#003481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 136v270c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45v-270z",
    fill: "#e0f4ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m512 136v270c0 24.81-20.19 45-45 45h-211v-315z",
    fill: "#b8e0f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m196 301h-120c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#ffda2d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m346 181h-270c-8.284 0-15 6.716-15 15s6.716 15 15 15h270c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#00b8f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m361 196c0 8.28-6.72 15-15 15h-90v-30h90c8.28 0 15 6.72 15 15z",
    fill: "#0097f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m286 241h-210c-8.284 0-15 6.716-15 15s6.716 15 15 15h210c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#00b8f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m301 256c0 8.28-6.72 15-15 15h-30v-30h30c8.28 0 15 6.72 15 15z",
    fill: "#0097f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m451 331v165c0 8.284-6.716 15-15 15h-120c-8.284 0-15-6.716-15-15v-165l10-10h130z",
    fill: "#ff641a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m451 331v165c0 8.28-6.72 15-15 15h-60v-190h65z",
    fill: "#f03800"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m392 331v180h-30v-180l10-10h10z",
    fill: "#0052c2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m392 331v180h-16v-190h6z",
    fill: "#003481"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    fill: "#8afa42",
    r: 15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 76,
    fill: "#fdbf00",
    r: 15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 76,
    fill: "#f03800",
    r: 15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m436 61h-90c-8.284 0-15 6.716-15 15s6.716 15 15 15h90c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#0052c2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m388.481 232.68c-5.919-8.879-19.02-8.913-24.962 0l-60 90c-1.643 2.464-2.519 5.359-2.519 8.32h150c0-2.961-.876-5.856-2.519-8.32z",
    fill: "#ffda2d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m451 331h-75v-104.99c4.76 0 9.52 2.23 12.48 6.67l60 90c1.64 2.46 2.52 5.36 2.52 8.32z",
    fill: "#fdbf00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.d0bb93fa915242fab24472b99fb8ff55.svg";
export { ForwardRef as ReactComponent };